import { Component, ViewContainerRef } from '@angular/core';

import { CommonModule } from '@angular/common';

import { CoreService } from '../core.service'
import { SettingsService } from '../settings/settings.service'
import { ProfileService } from '../profile/profile.service';
import { ScheduleService } from '../schedule/schedule.service';
import { TeamComponent } from '../team/team.component';

import { PosterComponent } from './poster.component';
import { PlayerComponent } from './player.component';
import { PlayerService } from './player.service';

import { Game, MediaEvent, Flavor } from '../app.models';
import { inplaceKeySort } from '../app.utils';
import { tzDatePipe, RangePipe } from '../app.pipes';


@Component({
	selector: 'app-tvbox',
	imports: [
		CommonModule, PosterComponent, TeamComponent, PlayerComponent,
		tzDatePipe, RangePipe
	],
	templateUrl: './tvbox.component.html',
	styleUrl: './tvbox.component.scss'
})
export class TvboxComponent {

	constructor(
		public core: CoreService,
		public settings: SettingsService,
		public schedule: ScheduleService,
		public profile: ProfileService,
		public player: PlayerService,
	){
		this.core.component_tvbox = this;
		this.change_player_layout( this.settings.player_layout );
	}

	subscriptions = [];
	ngOnInit(){
		this.subscriptions.push(
			this.core.stateshot_synced.subscribe( () => this.stateshot_parse() )
		);

		this.subscriptions.push(
			this.player.on_selected_player_change.subscribe( () => {
				if( this.player.autoplay_queued ){
					this.player.autoplay_queued = false;
					this.selectFeed();
				}
			})
		);

		if( this.core.media_events.length > 0 )
			this.stateshot_parse();

	}
	ngOnDestroy(){
		for( let sub of this.subscriptions ) sub.unsubscribe();
	}


	current_overlay: string = null;
	close_overlay( name?: string ){
		if( !name || this.current_overlay == name )
			this.current_overlay = null
	}
	select_overlay( name: string ){
		this.current_overlay = name
	}
	toggle_overlay( name: string ){
		if( this.current_overlay == name )
			this.current_overlay = null;
		else
			this.current_overlay = name;
	}

	cast_to_tv24all(){
		if( !this.profile.is_premium ){
			this.core.events.emit('paywall');
			return;
		}

		let url = this.player.tv24all_url;
		if( !url ) return;

		this.player.stop();
		window.open( url, '_blank' ).focus();
		this.player._sp.destroy();
		this.player._sp.message(
			"Your stream was moved elsewhere!",
			"Follow the directions in the new tab to cast your stream on a TV."
		);
	}





	events: any[] = []; //(Game|MediaEvent)
	game_id_to_media_events: { [key: number]: any[] } = {};
	game_id_to_prominent_media_status: { [key: number]: string } = {};
	media_event_id_to_flavors: { [key: number]: Flavor[] } = {};
	media_event_id_public: Set<number> = new Set();
	media_event_status_order = ["L", "R", "O", "P", "S"];

	events_order_key( e ){ //Used in the key_sort algorithm
		let media_status = e.status;
		if( e.type == 'Game' )
			media_status = this.game_id_to_prominent_media_status[e.id];

		return [
			-e.datetime.getTime(),
			-this.media_event_status_order.indexOf( media_status ),
			-e.id,
		]
	}

	autoselect_priority_seconds: number = 3600 * 2;
	autoselect_flavor( me: MediaEvent ): Flavor {
		for( let flavor of this.media_event_id_to_flavors[me.id] ){
			if( flavor.is_public ) return flavor;

			if( this.profile.is_premium ) //TODO: This section needs to be updated to support multi entitlement ordering...
				return flavor;
		}
		return null;
	}
	autoselect_from_candidates( candidates ) {
		for( let event of candidates ){
			let me_list = ( event.type == 'MediaEvent' ) ? [event] : this.game_id_to_media_events[event.id];
			for( let me of me_list ){
				let f = this.autoselect_flavor( me );
				if( f ) return [me, f];
			}
		}
		return null;
	}
	autoselect_media_event(){

		let candidates;
		let me_flavor;

		//Live games started in the last 2 hours
		candidates = this.events.filter( e => {
			if( e.type == 'MediaEvent' && e.status != "L" ) return false; //Both Game and MediaEvent status of not "Live" is filtered out
			if( e.type == 'Game' && this.game_id_to_prominent_media_status[e.id] != "L" ) return false;

			let timestamp = ( ( e.type == 'Game' ) ? (e.start_datetime || e.datetime) : e.datetime ).getTime();
			if( this.schedule.clock_timestamp < timestamp ) return false;
			if( timestamp + this.autoselect_priority_seconds * 1000 < this.schedule.clock_timestamp ) return false;

			return true;
		} )

		console.log(`autoselect: Trying selectiong from ${candidates.length} close, live candidates...`);
		inplaceKeySort( candidates, Math.random );
		if( me_flavor = this.autoselect_from_candidates( candidates ) )
			return me_flavor;


		//Any Live games
		candidates = this.events.filter( e => e.status == "L" )
		console.log(`autoselect: Trying selectiong from ${candidates.length} any live candidate...`);
		inplaceKeySort( candidates, Math.random );
		if( me_flavor = this.autoselect_from_candidates( candidates ) )
			return me_flavor;

		//First working replay.
		candidates = this.events.filter( e => e.status == "F" )
		console.log(`autoselect: Trying selectiong from ${candidates.length} any replayable candidate...`);
		if( me_flavor = this.autoselect_from_candidates( candidates ) )
			return me_flavor;

		console.log(`autoselect: Failed finding any valid candidated!`);
	}

	stateshot_parse(){ //AKA: adjust_events

		if( this.core.stateshot['configs']['autoselect_priority_seconds'] )
			this.autoselect_priority_seconds = this.core.stateshot['configs']['autoselect_priority_seconds'];

		this.events = [];
		this.game_id_to_media_events = {};
		this.game_id_to_prominent_media_status = {};
		this.media_event_id_to_flavors = {};
		this.media_event_id_public.clear();

		let games_seen = new Set();

		for( let me of this.core.media_events ){

			if( !this.media_event_id_to_flavors[me.id] )
				this.media_event_id_to_flavors[me.id] = [];

			for( let f of this.core.flavors )
				if( f.media_event_ids.has(me.id) ){
					this.media_event_id_to_flavors[me.id].push(f)
					if( f.is_public ) this.media_event_id_public.add( me.id )
				}

			if( me.game_id ){

				if( !this.game_id_to_media_events[me.game_id] )
					this.game_id_to_media_events[me.game_id] = [];

				this.game_id_to_media_events[me.game_id].push(me)

				if( !games_seen.has(me.game_id) ){
					games_seen.add( me.game_id );
					this.events.push( me.game );
				}

			} else {
				this.events.push( me );
			}
		}


		for( let [k, v] of Object.entries(this.game_id_to_media_events) ){
			inplaceKeySort( v, (me) => [
				this.media_event_status_order.indexOf(me.status),
				me.order,
				-this.media_event_id_to_flavors[me.id].length,
				me.title
			]);

			let set = new Set( v.map( me => me.status ) )
			for( let status of ["L", "R", "O", "P", "S"] ){ //Live, Replay, Over, Planned, Scrapped
				if( set.has(status) ){
					this.game_id_to_prominent_media_status[k] = status
					break
				}
			}
			if( !this.game_id_to_prominent_media_status[k] )
				this.game_id_to_prominent_media_status[k] = set.keys().next().value
		}

		inplaceKeySort( this.events, (e) => this.events_order_key(e) );

	}



	show_replay_media_events: boolean = true;
	show_live_media_events: boolean = true;
	show_planned_media_events: boolean = false;
	show_media_events_with_status( status ){
		if( status == "R" ) return this.show_replay_media_events;
		if( status == "L" ) return this.show_live_media_events;
		if( status == "P" ) return this.show_planned_media_events;
		return false;
	}


	//Player and Layout Selector
	change_player_type( name ){
		if( this.settings.player_type == name ) return;
		this.settings.set( 'player_type', name );
	}
	change_player_layout( name ){
		if( name !== "single" && !this.profile.is_premium ){
			this.core.events.emit('paywall');
		}
		name = this.profile.is_premium ? name : "single";

		if( name == "single" )
			this.player_ids = ["tl"];
		if( name == "quad" )
			this.player_ids = ["tl", "tr", "bl", "br"];
		else //Some kind of error, default to single
			this.player_ids = ["tl"];

		if( this.settings.player_layout == name ) return;
		this.settings.set( 'player_layout', name );
		setTimeout( () => this.player.resize() , 10);
	}

	//This is better as a string, as it can be passed as component input without changing type
	player_ids: string[];





	//Playback and selection
	selectFeed( me: MediaEvent = null, flavor = null ){

		if( me === null )
			[me, flavor] = this.autoselect_media_event();

		if( flavor === null )
			flavor = this.autoselect_flavor( me );

		if( !flavor ){


			//If the user is not premium, and could've played something if they were, throw a paywall event.
			if( !this.profile.is_premium )
				for( let flavor of this.media_event_id_to_flavors[me.id] )
					if( !flavor.is_public ){
						this.core.events.emit('paywall');
						return
					}

			return;
		}

		if( !this.profile.is_premium && !flavor.is_public ){
			this.core.events.emit('paywall');
			return;
		}

		this.current_overlay = null;
		this.player.assign( me, flavor );
	}
	selectFirstFeed( g: Game ){
		let me = this.game_id_to_media_events[g.id][0]
		this.selectFeed(me)
	}


	async adminAction( media_event_id, flavor_id, action, event ){
		let btn = event.target;

		if( btn.classList.contains("loading") ) return;
		btn.classList.remove("success")
		btn.classList.remove("failure")
		btn.classList.add("loading")


		let response = await this.core.json_request( "POST", "/api/v1/stream/admin_action",
			{
				'token': this.profile.user.token,
				'media_event_id':media_event_id,
				'flavor_id':flavor_id,
				'action': action
			}, { withCredentials: true }
		);

		if( !response.ok ){
			btn.classList.remove("loading")
			btn.classList.add("failure")
			return;
		}

		btn.classList.remove("loading")
		btn.classList.add("success")

	}


}
